import React from 'react';
import {Route, Routes} from 'react-router-dom';
import LazyComponents from './LazyComponents';
import Layout from '../components/Layout';
import routes from './routes.json';


function MarkexRoutes() {

  return (
    <Layout>
      <Routes>
        <Route
          path={routes['landing']}
          caseSensitive={true}
          index={true}
          element={(<LazyComponents.Landing/>)}
        />
        <Route path={routes['wholesaler']}
          caseSensitive={true}
          index={true}
          element={(<LazyComponents.Wholesaler/>)}
        />
        <Route path={routes['manage-users']}
          caseSensitive={true}
          element={(<LazyComponents.ManageUsersList/>)}
        />
        <Route path={routes['manage-roles']}
          caseSensitive={true}
          element={(<LazyComponents.ManageRoles/>)}
        />
        <Route path={routes['manage-categories']}
          caseSensitive={true}
          element={(<LazyComponents.ManageCategories/>)}
        />
        <Route path={routes['session-expired']}
          caseSensitive={true}
          element={(<LazyComponents.SessionExpired/>)}
        />
      </Routes>
    </Layout>
  );

}

export default MarkexRoutes;
